/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FieldLocationFinal } from '@folio/stripes-acq-components';
import { required } from '../../../utils/utils';
import useDataByName from '../../../hooks/useDataByName';

const propTypes = {
  fieldValues: PropTypes.object,
  fieldName: PropTypes.string,
};

function LocationFieldComponent({ fieldValues, fieldName }) {
  const { locale } = useIntl();
  const intl = useIntl();

  // Extract field configuration including template settings
  const {
    label,
    isRequired,
    canEdit,
    dataOptionsLimits, // Template-configured location restrictions
  } = fieldValues;

  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  // Get all locations data
  const allLocations = useDataByName('locations');

  // Filter locations based on template configuration and apply translation
  const filterLocations = (locations) => {
    const activeLocations = (locations || []).filter(
      (location) => location.isActive,
    );

    // If template restricts locations, filter to only allowed ones
    let filteredLocations = activeLocations;
    if (dataOptionsLimits?.length) {
      const allowedIds = dataOptionsLimits.map((item) => item.value);
      filteredLocations = activeLocations.filter((location) =>
        allowedIds.includes(location.id),
      );
    }

    // Apply translation to location names
    return filteredLocations.map((location) => ({
      ...location,
      name: intl.formatMessage({
        id: `ui-tenant-settings.locations.name.${location.name}`,
        defaultMessage: location.name,
      }),
    }));
  };

  // Get prepopulated location IDs (either from template restrictions or all active locations)
  const getPrepopulatedIds = () => {
    if (dataOptionsLimits?.length) {
      return dataOptionsLimits.map((item) => item.value);
    }

    const activeLocations = (allLocations || []).filter(
      (location) => location.isActive,
    );
    return activeLocations.map((location) => location.id);
  };

  return (
    <FieldLocationFinal
      name={fieldName}
      locationsForDict={allLocations || []}
      prepopulatedLocationsIds={getPrepopulatedIds()}
      filterLocations={filterLocations}
      labelId={fieldLabel}
      required={isRequired}
      validate={isRequired ? required : undefined}
      isDisabled={!canEdit}
    />
  );
}

LocationFieldComponent.propTypes = propTypes;

export default LocationFieldComponent;
